import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { invitationAPI } from '../services/api';
import api from '../services/api';
import './RegisterClub.css';

function SignupInvite() {
  const [searchParams] = useSearchParams();
  const clubId = searchParams.get('clubId');
  const navigate = useNavigate();

  const [emails, setEmails] = useState('');
  const [phones, setPhones] = useState('');
  const [mode, setMode] = useState('email');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(0);
  const [error, setError] = useState('');
  const [inviteLink, setInviteLink] = useState(null);
  const [linkCopied, setLinkCopied] = useState(false);

  const handleSendEmail = async () => {
    setSending(true);
    setError('');
    const emailList = emails.split(/[,\n]/).map(e => e.trim()).filter(Boolean);
    if (emailList.length === 0) { setError('Enter at least one email'); setSending(false); return; }
    try {
      const data = await invitationAPI.send(clubId, emailList);
      setSent(prev => prev + (data.sent?.length || 0));
      setEmails('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send');
    }
    setSending(false);
  };

  const handleSendSms = async () => {
    setSending(true);
    setError('');
    const phoneList = phones.split(/[,\n]/).map(p => p.trim()).filter(Boolean);
    if (phoneList.length === 0) { setError('Enter at least one number'); setSending(false); return; }
    try {
      const res = await api.post(`/api/club/${clubId}/invite-sms`, { phones: phoneList });
      setSent(prev => prev + (res.data.sent || 0));
      setPhones('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send SMS');
    }
    setSending(false);
  };

  const handleGenerateLink = async () => {
    try {
      const data = await invitationAPI.generateLink(clubId);
      if (data.success) setInviteLink(data.url);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed');
    }
  };

  const handleCopyLink = async () => {
    if (!inviteLink) return;
    try { await navigator.clipboard.writeText(inviteLink); } catch { /* fallback */ }
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };

  const handleNext = () => {
    navigate(`/signup/fund?clubId=${clubId}`);
  };

  const handleSkip = () => {
    navigate(`/signup/fund?clubId=${clubId}`);
  };

  return (
    <div className="register-club-wrapper">
      <div className="register-club-container-dark">
        <div className="register-club-logo">
          <img src="/logo.png" alt="Punt Club Logo" />
        </div>

        <h2 className="register-club-title">Invite Your Mates</h2>
        <p className="register-club-subtitle">A punting club is better with mates. Invite a few now, or skip and do it later.</p>

        {/* Progress */}
        <div className="progress-steps" style={{ marginBottom: '1.5rem' }}>
          {['Register', 'Create Club', 'Link Bookie', 'Invite Mates', 'Fund Club'].map((s, i) => (
            <div key={i} className={`progress-step ${i === 3 ? 'active' : i < 3 ? 'completed' : ''}`}>
              <div className="step-number">{i + 1}</div>
              <div className="step-info"><div className="step-title">{s}</div></div>
            </div>
          ))}
        </div>

        {sent > 0 && (
          <div className="success-message" style={{ marginBottom: '1rem' }}>
            {sent} invitation(s) sent!
          </div>
        )}

        {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}

        {/* Mode Tabs */}
        <div style={{ display: 'flex', gap: 8, marginBottom: '1rem' }}>
          {[{k: 'email', l: 'Email'}, {k: 'sms', l: 'SMS'}, {k: 'link', l: 'Link'}].map(t => (
            <button key={t.k} onClick={() => setMode(t.k)} style={{
              flex: 1, padding: '8px', border: 'none', borderRadius: 6, cursor: 'pointer',
              background: mode === t.k ? '#fbbf24' : 'rgba(255,255,255,0.05)', color: mode === t.k ? '#000' : '#999',
              fontWeight: 600, fontSize: '0.8rem'
            }}>{t.l}</button>
          ))}
        </div>

        {mode === 'email' && (
          <div>
            <textarea value={emails} onChange={e => setEmails(e.target.value)}
              placeholder={"mate1@email.com\nmate2@email.com"} rows={3}
              style={{ width: '100%', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', padding: '0.75rem', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box', marginBottom: '0.75rem' }} />
            <button onClick={handleSendEmail} disabled={sending || !emails.trim()} className="btn-warning" style={{ width: '100%', marginBottom: '0.75rem' }}>
              {sending ? 'Sending...' : 'Send Email Invites'}
            </button>
          </div>
        )}

        {mode === 'sms' && (
          <div>
            <textarea value={phones} onChange={e => setPhones(e.target.value)}
              placeholder={"0400123456\n0412345678"} rows={3}
              style={{ width: '100%', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', padding: '0.75rem', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box', marginBottom: '0.75rem' }} />
            <button onClick={handleSendSms} disabled={sending || !phones.trim()} className="btn-warning" style={{ width: '100%', marginBottom: '0.75rem' }}>
              {sending ? 'Sending...' : 'Send SMS Invites'}
            </button>
          </div>
        )}

        {mode === 'link' && (
          <div>
            {inviteLink ? (
              <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem' }}>
                <input readOnly value={inviteLink} style={{ flex: 1, background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#fff', padding: '0.75rem', fontSize: '0.8rem', boxSizing: 'border-box' }} />
                <button onClick={handleCopyLink} style={{ background: linkCopied ? '#10b981' : '#fbbf24', color: linkCopied ? '#fff' : '#000', border: 'none', borderRadius: '8px', padding: '0 1.25rem', cursor: 'pointer', fontWeight: 600 }}>
                  {linkCopied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            ) : (
              <button onClick={handleGenerateLink} className="btn-warning" style={{ width: '100%', marginBottom: '0.75rem' }}>
                Generate Invite Link
              </button>
            )}
          </div>
        )}

        <div className="form-actions" style={{ marginTop: '1.5rem' }}>
          <button onClick={handleNext} className="btn-warning" style={{ flex: 1 }}>
            {sent > 0 ? 'Continue to Fund Club' : 'Next'}
          </button>
        </div>

        <div className="skip-link">
          <a href="#" onClick={e => { e.preventDefault(); handleSkip(); }}>
            Skip for now
          </a>
        </div>
      </div>
    </div>
  );
}

export default SignupInvite;
